import { cn } from "cn";
import { format, isToday, isYesterday, parseISO } from "date-fns";

const getDisplayDate = (date: Date | string) => {
  const parsedDate = typeof date === "string" ? parseISO(date) : date;

  if (isToday(parsedDate)) return "Today";
  if (isYesterday(parsedDate)) return "Yesterday";

  return format(parsedDate, "MMM d, yyyy");
};

export const LineAndDate = ({
  date,
  className,
}: {
  date: string;
  className?: string;
}) => {
  const dateFormat = getDisplayDate(date);

  return (
    <div
      className={cn(
        /* sorted */
        "relative flex",
        "items-center justify-center",
        "w-full h-11",
        className,
      )}
    >
      <div className="absolute bg-bg-dark-min h-px w-full" />
      <div className="absolute z-5 px-2 bg-bg-light">
        <p className="text-sm text-text-dark-high">{dateFormat}</p>
      </div>
    </div>
  );
};
